import { Component, OnInit } from '@angular/core';
import { Promise, reject } from 'q';
import { Message }  from './message';

// import swal from 'sweetalert2'
declare var $:any;
declare var swal:any;

export class SweetMessage { 

    private msg: Message;

    constructor(){
        this.msg = new Message();
    }

    showMessage(type, text?) {
        let Promise;
        if(type == 'delete-confirm-message')
            return this.modalDelete(text);
        else if(type == 'success-message')
            return this.modalSuccess(text);
        else if(type == 'error-message')
            return this.modalError(text);
        else if(type == 'single-message')
            return this.singleModal(text);
    }



    private modalDelete(text?){
        if(text == undefined || text == null )
            text = this.msg.deleteQuestion;

        return Promise((resolve, reject) =>{
            swal({
                title: '',
                html: text,
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: 'Aceptar',
                cancelButtonText:'Cancelar',
                buttonsStyling: false
            }).then(res => {
                if(res == true){
                    resolve("ok");
                }
                else{
                    resolve("cancelar");
                }
            }).catch(er => {
                reject(er);
            });
       });
    }

    private modalSuccess(text?){
        if(text == undefined || text == null )
            text = this.msg.success;

        return Promise((resolve, reject) =>{
            swal({
                type: "success",
                text: text,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            });
        });
    }

    private modalError(text?){
        return Promise((resolve, reject) =>{
            swal({
                type: "error",
                text: text,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            });
        });
    }

    private singleModal(html?){
        return Promise((resolve, reject) =>{
            swal({
                html: html,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-fill btn-success",
                confirmButtonText: "Aceptar",
                closeOnClickOutside: false,
            });
        });
    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/config/sweet-message.ts